export enum SelectListItemType {
	RADIO = 'radio',
	CHECKBOX = 'checkbox',
}